var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserProjCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-User"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User",
    clipPath: "url(#clip-User)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1414",
    transform: "translate(-16942 -4691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_532",
    d: "M201.62,32.62a1,1,0,0,1-1-1v-2.2a3.4,3.4,0,0,0-3.4-3.4h-8.8a3.405,3.405,0,0,0-3.4,3.4v2.2a1,1,0,0,1-2,0v-2.2a5.407,5.407,0,0,1,5.4-5.4h8.8a5.406,5.406,0,0,1,5.4,5.4v2.2a1,1,0,0,1-1,1",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_533",
    d: "M192.993,22.061a5.75,5.75,0,1,1,5.75-5.75,5.757,5.757,0,0,1-5.75,5.75m0-9.5a3.75,3.75,0,1,0,3.75,3.75,3.755,3.755,0,0,0-3.75-3.75",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_534",
    d: "M208.215,32.617a1,1,0,0,1-1-1v-2.2a3.4,3.4,0,0,0-2.551-3.286,1,1,0,0,1,.5-1.938,5.4,5.4,0,0,1,4.051,5.223v2.2a1,1,0,0,1-1,1",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_535",
    d: "M200.516,21.49a1,1,0,0,1-.248-1.969,3.4,3.4,0,0,0,0-6.585,1,1,0,1,1,.5-1.938,5.4,5.4,0,0,1,0,10.461,1.025,1.025,0,0,1-.25.031",
    transform: "translate(16769 4691)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProjCard);
export default __webpack_public_path__ + "static/media/user-proj-card.ad82ecc0.svg";
export { ForwardRef as ReactComponent };